// extracted by mini-css-extract-plugin
export default {"iconsLink":"Links_iconsLink__G01LV"};